module.exports = __webpack_public_path__ + "static/lauren_groff-287294142411be8a2c9c8451d3f7c78c.jpg";